import React, { useState } from "react";
import { Divider, Grid, Button, Icon, Menu } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./HeaderComp.css";

const HeaderComp = () => {
  const [dropdownView, setdropdownView] = useState("none");
  const navigate = useNavigate();

  const mobileViewNav = () => {
    setdropdownView((prev) => (prev === "none" ? "flex" : "none"));
  };

  const logOut = () => {
    Cookies.remove("authTokens");
    navigate("/login");
  };

  return (
    <div>
      <Grid padded className="tablet computer only">
        <Menu borderless fluid fixed="top" className="topbar-menu">
          <Menu.Item header as="a" className="brand">
            <div className="header-brand-card">
              <div className="brand-mark">SS</div>
              <div>
                <div className="brand-title">SS Business</div>
                <div className="brand-subtitle">Back Office Suite</div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item onClick={() => logOut()} className="logout-link">
              Log Out
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </Grid>

      <Grid padded className="mobile only">
        <Menu borderless fluid fixed="top" className="topbar-menu">
          <Menu.Item header as="a" className="brand">
            <div className="header-brand-card">
              <div className="brand-mark">SS</div>
              <div>
                <div className="brand-title">SS Business</div>
                <div className="brand-subtitle">Back Office Suite</div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              <Button basic icon toggle onClick={() => mobileViewNav()}>
                <Icon name="content" />
              </Button>
            </Menu.Item>
          </Menu.Menu>
          <Menu
            borderless
            fluid
            vertical
            className="topbar-menu mobile-dropdown"
            style={{
              display: dropdownView,
            }}
          >
            <Menu.Item onClick={() => logOut()} className="logout-link">
              Log Out
            </Menu.Item>
            <Divider fitted />
          </Menu>
        </Menu>
      </Grid>
    </div>
  );
};

export default HeaderComp;
